import React from 'react';
import { Stack } from '@mui/material';
import { IContract } from '../../../../../../types/contract';
import { ContractExtractionResult } from '../../../../../../types/aiOutput';
import TCDeviationsSection from '../../ContractTCDeviations';

interface DeviationsTabProps {
  contract: IContract;
  aiOutputs: ContractExtractionResult[];
}

const DeviationsTab: React.FC<DeviationsTabProps> = ({
  contract,
  aiOutputs,
}) => {
  return (
    <Stack>
      <TCDeviationsSection contract={contract} aiOutputs={aiOutputs} />
    </Stack>
  );
};

export default DeviationsTab;
